import React, { Component } from 'react';
import './register.css'
import { Link } from 'react-router-dom';
import {
    Col, Row, Form, Button,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import RenderField from '../../../Components/Fields/fields'
import { Inputs } from './inputSettings'
import validate from './validation';
import LoadingBar from 'react-redux-loading-bar'
import Logo from '../../../Assets/images/Logo.png'
import String from '../../../Assets/locals'
import { changeLang } from '../../../Redux/Action/LoginAction'
import UpgradeTerms from './UpgradeTerms/UpgradeTerms.js'
import { RegisterRequest } from '../../../Redux/Action/RegisterAction'
import Loading from '../../../Components/Loading/Loading'

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            closeAll: false,
            RedirectTo: false,

            accept: false,
            acceptErr: false,
            showTerms: false,
        };


    }
    HideTerms = () => {
        this.setState({ showTerms: false })
    }
    onSubmit = (values) => {
        if (this.state.accept) {
            let data = new FormData();
            data.append('name', values.name )
            data.append('email', values.email )
            data.append('phone', values.phone )
            data.append('password', values.password )
            data.append('type', localStorage.getItem("JazanType"))

            this.props.RegisterRequest(data, this.props.lang)
        } else {
            this.setState({ acceptErr: true })
        }
    }
    Acceptance(e) {
        this.setState({ acceptErr: false })
        if (e.target.checked) {
            this.setState({ accept: true })
        } else {
            this.setState({ accept: false })
        }
    }
    componentWillMount() {
        let lang = localStorage.getItem("JazanLanguage") ? JSON.parse(localStorage.getItem("JazanLanguage")) : null
        if (lang) {
            this.props.changeLang(lang)
        } else {
            this.props.changeLang(JSON.parse(localStorage.getItem("ar")))
        }
    }
    render() {
        const { handleSubmit, submitting } = this.props
        let type = localStorage.getItem("JazanType")
        if (this.props.token) {
            if (this.props.location.state.redirect) {
                return (
                    <Redirect to={this.props.location.state.redirect} />
                )
            } else {
                if (type === 'MAGAZINE')
                    return (
                        <Redirect to='/Magazin' />
                    )
                if (type === 'PROMOTION')
                    return (
                        <Redirect to='/Promotion' />
                    )
            }
        }
        let lang = this.props.lang
        String.setLanguage(lang)
        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "#006B30" }} />
                </div>

                <div className="bg-signUp">
                {this.props.loading && <Loading />}
                    <div className="container">
                        <div className="signup-form">
                            <div style={{ textAlign: "center" }}><img src={Logo} className="logo" alt="Logo" /></div>

                            <Row>
                                <Col md="12"> <h3 style={{ float: lang === "ar" ? "right" : 'left' }}> {String.signup} </h3> </Col>
                            </Row>
                            <Row style={{padding:"0 2%"}}>
                                <Col md="12" lg="12" >
                                    <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        {
                                            Inputs.map((row, ind) => {

                                                return (
                                                    <Row className="d-flex flex-row-reverse">
                                                        {
                                                            row.map((element, index) => {

                                                                return (
                                                                    <Field key={index}
                                                                        lang={lang}
                                                                        type={element.type}
                                                                        name={element.name}
                                                                        component={RenderField}
                                                                        label={lang === "ar" ? element.label.ar : element.label.en}
                                                                        placeholder={element.placeholder ? (lang === "ar" ? element.placeholder.ar : element.placeholder.en) : ""}
                                                                        options={element.options}
                                                                        optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                                        size={element.size}
                                                                    />
                                                                )
                                                            })

                                                        }
                                                    </Row>
                                                )
                                            })
                                        }
                                        <Col md="12" className="d-flex flex-row-reverse">
                                            <input type="checkbox" onClick={(e) => this.Acceptance(e)} style={{marginTop:"0.5rem"}} /><span className="pl-2 pr-2"> {String.acceptSignup}
                                                <span className="upgradeWord" onClick={() => this.setState({ showTerms: true })}> {String.upgrade} </span> </span>
                                        </Col>
                                        {this.state.acceptErr &&
                                            <Col>
                                                <div style={{ textAlign: lang === "ar" ? "right" : 'left', marginTop: '10px' }}>
                                                    <span className="mt-3" style={{ color: 'red', fontSize: '0.8rem' }}> {String.acceptErr} </span> </div>
                                            </Col>
                                        }

                                        <Col md="12" className="login-submit-Btn" style={{ marginTop: '2%', textAlign: lang === "ar" ? "right" : 'left' }} id="loginBtn">
                                            <Button type="submit" className="btn submitBtn" disabled={submitting}>
                                                {String.signup}
                                            </Button>
                                        </Col>
                                    </Form>
                                    <Row className="login-ques mt-2 mb-2" >

                                        <Col lg="12" md="12" className="p-0 headingMobile" style={{ textAlign: localStorage.getItem("Language") === "ar" || localStorage.getItem("Language") === "" ? "right" : "" }}>
                                            <p style={{ float: lang === "ar" ? "right" : 'left', margin: "0px 3%", fontSize: "18px", color: "rgb(67, 67, 67)", direction: lang === "ar" ? "rtl" : 'ltr' }}>
                                                <Link to='/login' className="login-click" style={{ fontSize: "18px" }} > {String.backlogin} </Link> </p>
                                        </Col>
                                    </Row>
                                    {this.state.showTerms &&
                                        <UpgradeTerms Hide={this.HideTerms} />
                                    }
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        lang: state.login.language,
        token: state.login.token,
        loading: state.login.loading
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        changeLang,
        RegisterRequest

    }
    , dispatch
)
export default reduxForm({
    form: 'SignUpValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(SignUp));
